export function distanceMeters(lat1, lng1, lat2, lng2) {
  const R = 6371000;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

export function findBestPOI(lat, lng, pois, { sources, orgId }) {
  if (lat == null || lng == null || !pois?.length) return null;

  const candidates = [];
  for (const p of pois) {
    const isOrg = p.organization_id && p.organization_id === orgId;
    const isGlobal = p.organization_id == null;
    if (isOrg && !sources.org) continue;
    if (isGlobal && !sources.global) continue;
    if (!isOrg && !isGlobal) continue;

    const d = distanceMeters(lat, lng, p.latitude, p.longitude);
    if (d > (p.radius_meters ?? 0)) continue;
    candidates.push({ poi: p, scope: isOrg ? 'org' : 'global' });
  }

  if (!candidates.length) return null;

  candidates.sort((a, b) => {
    if (a.scope !== b.scope) return a.scope === 'org' ? -1 : 1;
    if (a.poi.radius_meters !== b.poi.radius_meters) {
      return a.poi.radius_meters - b.poi.radius_meters;
    }
    return String(a.poi.id).localeCompare(String(b.poi.id));
  });
  return candidates[0].poi;
}

// formatPoiLabel moved to @trackizy/formatters so mobile can share.
export { formatPoiLabel } from '@trackizy/formatters';
